import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectQbrDocumentUid } from 'partner360/features/QBR/selectors'

import { fetchELTVersionsByQBR } from '../api/fetchELTVersionsByQBR'
import { IELTVersions } from '../models/IELTVersions'

export const useELTVersions = () => {
  /** -------------------- State ----------------------- */

  const [eltVersions, setELTVersions] = useState<IELTVersions[]>([])
  const [isLoading, setIsLoading] = useState(false)

  /** -------------------- Selectors ----------------------- */

  const documentUid = useSelector(selectQbrDocumentUid)

  /** -------------------- Methods ----------------------- */

  const fetchELTVersions = useCallback(async () => {
    if (documentUid) {
      setIsLoading(true)
      const fetchedData = await fetchELTVersionsByQBR(documentUid)
      setELTVersions(fetchedData.Data)

      setIsLoading(false)
    }
  }, [documentUid])

  /** -------------------- Effects ----------------------- */

  useEffect(() => {
    fetchELTVersions()
  }, [fetchELTVersions])

  /** -------------------- Result ----------------------- */

  return {
    eltVersions,
    isELTAvailable: !isLoading && eltVersions?.length > 0,
    isLoading,
    refresh: fetchELTVersions,
  }
}
